import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from 'src/app/shared/spinner/spinner.service';
import { WorkspaceService } from 'src/app/shared/services/workspace.service';
import { SidenavService } from 'src/app/shared/sidenav-bar/sidenav.service';
import { MetaService } from 'src/app/bloom/services/meta-service';
import { ResourcePermissionService } from 'src/app/shared/services/resource-permission.service';
import { ConnectionService } from '../../organization/connection.service';
import { FlowService } from 'src/app/flow/flow.service';
import { StarchService } from 'src/app/shared/services/starch.service';

@Component({
    selector: 'app-workspace-approval',
    templateUrl: './workspace-approval.component.html',
    styleUrls: ['./workspace-approval.component.scss'],
    standalone: false
})
export class WorkspaceApprovalComponent implements OnInit {

  permissionId:any;
  isAccepted:boolean= false;
  action: string= '';
  inviter: any;
  inviteeMap: any = {};
  workspaceMap: any = {};
  entityType: string = "";
  bloomMap: any = {};
  connectionMap: any = {};
  flowMap: any = {};
  starchMap: any = {};
  isActionRepeats:boolean = false;
  actionMessage: string;
  constructor(
    private route: ActivatedRoute,
    private spinner: SpinnerService,
    private router: Router,
    public ws : WorkspaceService,
    public sidenavService: SidenavService,
    public resourcePermission: ResourcePermissionService,
    public bloomMetaService: MetaService,
    public connectionService: ConnectionService,
    public flowService: FlowService,
    public starchService: StarchService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(async params => {
      if(params.p) this.permissionId = params.p;
      if(params.a) this.action = params.a;
      if(params.u) this.inviter = params.u;
      if(this.action == 'accept') this.isAccepted = true;
      if(params.e) this.entityType = params.e;
      // if(params.hasOwnProperty("accept")) this.isAccepted = true;
      console.log("params", params);


      this.checkAndApprove()
    })
  }

  async checkAndApprove(){
    this.inviteeMap = await this.ws.getUserbyId(this.inviter)
    console.log("inviteeMap", this.inviteeMap)
    this.spinner.show();

    var permission:any = {};

    if(this.entityType == 'bloom'){
      permission = await this.resourcePermission.getPermission(this.permissionId);
      let result = await this.bloomMetaService.getBloomByCode(permission.resource_id, this.inviteeMap.email);
      if(result) this.bloomMap = result[0]
      console.log("this.bloomMap ", this.bloomMap )
    } else if(this.entityType == 'workspace') {
      permission = await this.resourcePermission.getPermission(this.permissionId);
    } else if(this.entityType == 'connection') {
      permission = await this.resourcePermission.getPermission(this.permissionId);
      let authString = await this.connectionService.getPreAuthenticatedTokenForEmail(permission.created_by)
      this.connectionMap = await this.connectionService.getConnection(permission.resource_id, authString)
      console.log("this.connectionMap ", this.connectionMap);
    } else if(this.entityType == 'flow') {
      permission = await this.resourcePermission.getPermission(this.permissionId);
      this.flowMap = await this.flowService.getFlow(permission.resource_id)
      console.log("this.flowMap ", this.flowMap);
    } else if(this.entityType == 'starch') {
      permission = await this.resourcePermission.getPermission(this.permissionId);
      this.starchMap = await this.starchService.getStarchBase(permission.resource_id)
      console.log("this.starchMap ", this.starchMap);
    }

    console.log("permission", JSON.parse(JSON.stringify(permission)));
    if(permission.status != 'Invited'){
      this.isActionRepeats = true;
      if(permission.status = 'Active'){
        this.actionMessage = "Great news! You've already been accepted. You can now log in and start using this."
      } else if(permission.status = 'Rejected'){
        this.actionMessage = "It looks like you've already rejected this. Unfortunately, you can't accept it now. Please contact your admin to change your sharing options."
      }
      this.spinner.hide();
      return;
    } else if(this.isAccepted && permission.status == 'Invited'){
      permission.status = 'Active';
      if(this.entityType == 'workspace'){
        let workspace:any = await this.ws.getWorkspace(permission.workspace_id, permission.created_by);
        this.workspaceMap = workspace;
        workspace.users.push(permission.user_id);
        await this.ws.updateWorkspace(workspace, permission.created_by)
      }
    } else if(permission.status == 'Invited') {
      permission.status = 'Rejected';
    }

    await this.resourcePermission.updatePermission(permission);
    this.spinner.hide();
  }

  navigateToSignUp() {
    let queryParams = {};
    if(this.entityType == 'workspace'){
      queryParams = {
        selected_workspace: this.workspaceMap._id
      }
    }
    if(this.entityType == 'connection' || this.entityType == 'flow' || this.entityType == 'starch' || this.entityType == 'bloom'){
      queryParams = {
        entityType: this.entityType
      }
    }
    this.router.navigate(['sign-up'], { queryParams: queryParams });
  }

  navigateToGuest(){
    this.router.navigate(['']);
  }

}
